import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from '../../services/http.service';
import { AuthenService } from '../../services/authen.service';
import { HelperService } from '../../services/helper.service';
@Component({
    selector: '',
    templateUrl: './ffm-matrix-v2-detail.html',
})
export class FFMMatrixV2DetailComponent implements OnInit {
    subs: any = null;
    id: number = 0;
    item: any = null;


    constructor(private http: HttpService, private auth: AuthenService, private route: ActivatedRoute, private helper: HelperService, private router: Router) {
        this.subs = route.params.subscribe(params => {
            this.id = params['id'];
        })
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

    ngOnInit() {

        let idGet = (this.id == undefined || this.id == null) ? 0 : this.id;

        this.load(idGet);
    }

    load(id: number) {
        this.http.get(`api/FFMMatrixV2/GetFFMMatrixById/${id}`, res => {
            this.item = res.Result;
        });
    }

    isInputValid() {
        let msg = null;
        if (this.item.FFM == null) {
            msg = 'FFM is required'
        }
        if (this.item.BCCode == null) {
            msg = 'BC code is required'
        }
        
        return msg;
    }

    onSave() {
        let err = this.isInputValid();
        if (err == null) {
            this.http.save('api/FFMMatrixV2/SaveFFMMatrix', this.item, res => {
                this.load(res.LongID);
                this.router.navigate(['/ffm-matrix-v2-detail', res.LongID]);
            });
        } else {
            this.helper.alertFailed(err);
        }
    }



}
